import { makeStyles, Theme, createStyles } from '@material-ui/core'
import React from 'react'
import Size from '../Sizes/Size'
import clsx from 'clsx'
import AvailabilityChecker from '../Shop/AvailabilityChecker'
import QuantitySelector from '../Shop/QuantitySelector'
import Button from '../Button/Button'
import CMSText from '../Global/CMSText'

type Tprops = {
  cart: any
  currentItem: any
  openModal: boolean
  productSettings: any
  stock: any
  t: any
  setOpenModal: any
  addProductWithSize: any
  main: any
  hasQtySelector: boolean
  availabilityChecker: any
  availability: any
  unavailability: any
  parameters: any
  quantity: any
  onQuantityChange: any
  isBuyableProduct: boolean
  isSki: boolean
  skiText: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectors: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    availybilityCheckerRow: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      gap: theme.spacing(1),
    },
  })
)

const Selectors = ({
  cart,
  currentItem,
  openModal,
  productSettings,
  stock,
  t,
  setOpenModal,
  addProductWithSize,
  main,
  hasQtySelector,
  availabilityChecker: availybilityChecker,
  availability,
  unavailability: unvailabilities,
  parameters,
  quantity,
  onQuantityChange,
  isBuyableProduct,
  isSki,
  skiText,
}: Tprops) => {
  const productClasses = useStyles()
  const currentVariant =
    currentItem.variants[Object.keys(currentItem.variants)[0]]

  return (
    <div className={productClasses.selectors}>
      {Object.keys(currentItem.variants).length > 1 ? (
        <>
          {cart && cart.item && cart.item.items && (
            <Size
              open={openModal}
              text={productSettings}
              stock={stock}
              t={t}
              handleClose={() => setOpenModal(false)}
              products={currentItem}
              cart={cart}
              skiText={skiText}
              isSki={isSki}
              onQuantityChange={addProductWithSize}
              settings={main}
            />
          )}
        </>
      ) : hasQtySelector ? (
        <div
          className={clsx(
            availybilityChecker &&
              !availability &&
              productClasses.availybilityCheckerRow
          )}
        >
          {availybilityChecker && !availability ? (
            <AvailabilityChecker
              t={t}
              cart={cart}
              texts={productSettings?.data}
              unvailabilities={unvailabilities}
              endLeasingDate={parameters?.items?.maximumLeasingDays}
            />
          ) : (
            <QuantitySelector
              small={false}
              align="left"
              value={quantity}
              handleChange={onQuantityChange}
              loading={cart.loading}
              min={0}
              max={currentVariant.maxStock ? currentVariant.maxStock : null}
              variantSku={currentVariant.sku}
            />
          )}
        </div>
      ) : (
        <div
          className={clsx(
            availybilityChecker &&
              !availability &&
              productClasses.availybilityCheckerRow
          )}
        >
          {availybilityChecker && !availability && (
            <AvailabilityChecker
              t={t}
              cart={cart}
              texts={productSettings?.data}
              unvailabilities={unvailabilities}
              endLeasingDate={parameters?.items?.maximumLeasingDays}
            />
          )}
          <Button
            className="product__btn-addtocart"
            variant="contained"
            color="primary"
            disabled={!availability}
            onClick={() => onQuantityChange(quantity + 1)}
          >
            {!isBuyableProduct ? (
              <CMSText
                asText
                data={productSettings?.data?.choose_button}
                defaultText={t('texts:single_product:choose_button')}
              />
            ) : (
              <CMSText
                asText
                data={productSettings?.data?.buy_button}
                defaultText={t('texts:single_product:buy_button')}
              />
            )}
          </Button>
        </div>
      )}
    </div>
  )
}

export default Selectors
